import React from 'react';
import { connect } from 'react-redux';
import { changePin } from '../../../redux/userAuthentication/userAuth.actions';
import { onLoginEnter } from '../../../utils/commonFunctions';

const mapStateToProps = (state) => {
	return {
		pin: state.rootReducer.loginDetails.pin,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onPinChange: (pin) => dispatch(changePin(pin)),
	};
};

const LoginForm = ({ pin, onPinChange }) => (
	<input
		aria-label="pin"
		autoComplete="password-field"
		onKeyDown={onLoginEnter}
		type="password"
		name="txtPin"
		id="txtPin"
		className="step-password-field input-text"
		placeholder="Enter PIN/ Licence Key"
		value={pin}
		onChange={(e) => onPinChange(e.target.value)}
	/>
);

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
